import { Validators } from "@angular/forms";
import { ProductCategoryEnum } from "src/app/core/enums/product-category.enum";
import { FormConfig } from "src/app/core/forms/engine/core-types";
import { CustomValidators } from "src/app/core/forms/validators/custom-validators";
import { TireProduct, TireSeasonType } from "src/app/core/interfaces/products-types/tire-product.interface";

export const TIRE_PRODUCT_FORM_CONFIG: FormConfig<TireProduct> = {
  name: 'tireProduct',
  description: 'Formulario para crear/editar llantas',

  fields: {
    // Campos heredados de Product
    id: {
      type: 'number',
      label: 'ID',
      disabled: true, // Los IDs no se editan
    },

    name: {
      type: 'text',
      label: 'Nombre del Producto',
      placeholder: 'Ej: Michelin Pilot Sport',
      required: true,
      validators: [
        Validators.minLength(3),
        Validators.maxLength(100),
      ],
    },

    code: {
      type: 'text',
      label: 'Código del Producto',
      placeholder: 'Ej: TYRE-SUMMER-001',
      required: true,
      validators: [],
      description: 'Formato: CATEGORIA-TIPO-NUMERO',
    },

    description: {
      type: 'textarea',
      label: 'Descripción',
      required: false,
      validators: [Validators.maxLength(500)],
    },

    identifier: {
      type: 'text',
      label: 'Identificador',
      required: false,
    },

    productCategoryId: {
      type: 'number',
      label: 'ID Categoría',
      initialValue: ProductCategoryEnum.TIRES,
      required: true,
    },

    subCategoryGuid: {
      type: 'text',
      label: 'GUID de Subcategoría',
      required: true,
    },

    imageUrl: {
      type: 'text',
      label: 'URL de Imagen',
      validators: [CustomValidators.url()],
      required: false,
    },

    brand: {
      type: 'select',
      label: 'Marca',
      required: true,
      options: [
        { label: 'Michelin', value: 'Michelin' as any },
        { label: 'Pirelli', value: 'Pirelli' as any },
        { label: 'Bridgestone', value: 'Bridgestone' as any },
        { label: 'Continental', value: 'Continental' as any },
      ],
    },

    model: {
      type: 'text',
      label: 'Modelo',
      required: true,
      validators: [Validators.minLength(2)],
    },

    brandLogo: {
      type: 'text',
      label: 'Logo de Marca (URL)',
      required: false,
      validators: [CustomValidators.url()],
    },

    // Campos específicos de TireProduct

    family: {
      type: 'text',
      label: 'Familia de Llantas',
      required: false,
    },

    tireSeason: {
      type: 'select',
      label: 'Temporada',
      required: true,
      options: [
        { label: 'Summer', value: TireSeasonType.SUMMER as TireSeasonType },
        { label: 'Winter', value: TireSeasonType.WINTER as TireSeasonType },
        { label: 'All season', value: TireSeasonType.ALL_SEASON as TireSeasonType },
      ],
    },

    width: {
      type: 'text',
      label: 'Ancho (mm)',
      required: true,
      validators: [],
      description: 'Rango: 100-400mm',
    },

    height: {
      type: 'text',
      label: 'Altura (%)',
      required: true,
      validators: [],
      description: 'Rango: 20-95%',
    },

    radius: {
      type: 'text',
      label: 'Radio (pulgadas)',
      required: true,
      validators: [],
      description: 'Rango: 10-30 pulgadas',
    },

    runflat: {
      type: 'checkbox',
      label: '¿Runflat?',
      required: false,
      initialValue: false,
    },

    extraload: {
      type: 'checkbox',
      label: '¿Extra Load?',
      required: false,
      initialValue: false,
    },

    threePMSF: {
      type: 'checkbox',
      label: '¿3PMSF?',
      required: false,
      initialValue: false,
    },

    noiseLevel: {
      type: 'number',
      label: 'Nivel de Ruido (dB)',
      required: true,
      validators: [
      ],
    },

    noiseCategory: {
      type: 'number',
      label: 'Noise Category',
      required: false,
      validators: [
      ],
    },

    wetGrip: {
      type: 'checkbox',
      label: '¿Wet Grip?',
      required: true,
    },

    rollingResistance: {
      type: 'number',
      label: 'Resistencia al Rodamiento',
      required: true,
      validators: [],
    },

    speedIndex: {
      type: 'text',
      label: 'Índice de Velocidad',
      required: true,
      placeholder: 'Ej: H, V, W, Y, Z',
      validators: [
      ],
    },

    loadIndex: {
      type: 'text',
      label: 'Índice de Carga',
      required: true,
      placeholder: 'Ej: 86, 94, 112',
      validators: [
      ],
    },

    efficiency: {
      type: 'text',
      label: 'Efficiency',
      required: false,
      placeholder: 'Ej: 86, 94, 112',
      validators: [

      ],
    },

    ecotax: {
      type: 'number',
      label: 'Ecotax',
      required: true,
      placeholder: 'Ej: 86, 94, 112',
      validators: [
      ],
    },
  },

  // Validadores a nivel de formulario
  formValidators: [],

  metadata: {
    category: 'products',
    type: 'tire',
    version: '1.0',
  },
};

